import type { PersonalizationProfile } from './profile'

export interface StepProps {
  profile: PersonalizationProfile
  update: (patch: Partial<PersonalizationProfile>) => void
  onNext: () => void
}

export function toggleValue(list: string[], value: string, max?: number): string[] {
  if (list.includes(value)) return list.filter((item) => item !== value)
  if (max && list.length >= max) return list
  return [...list, value]
}
